import ApiService from '@/api/ApiService'
import proxy from '@/shared/proxy'

const WebCheckInService = {
  GetHotelInfo (identifier: string, token: string) {
    return ApiService.getAsync(proxy.Hotelv1, `WebCheckIn/Booking/Identifier/${identifier}/Token/${token}`)
  },
  GetHotelInfoByBookingId (bookingId: string) {
    return ApiService.getAsync(proxy.Hotelv1, `WebCheckIn/Booking/${bookingId}`)
  },
  DecodeToken (token: string) {
    return ApiService.getAsync(proxy.Hotelv1, `WebCheckIn/DecodePhone?token=${token}`)
  }
}

export default WebCheckInService
